import React from 'react';

import * as Icons from './sprites';

export type IconName = keyof typeof Icons;

interface IconProps {
    name: IconName;
    className?: string;
    size?: number | string;
    height?: number | string;
    width?: number | string;
    color?: string;
    fill?: string;
    style?: React.CSSProperties;
    onClick?: (e: any) => void;
}

export const Icon: React.FC<IconProps> = ({
    name,
    size = 24,
    height,
    width,
    color,
    className,
    style,
    onClick,
}) => {
    const IconComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
        fillColor?: string;
    }> = Icons[name];
    if (!IconComponent) return null;

    return (
        <IconComponent
            width="100%"
            height="100%"
            className={className}
            onClick={(e: any) => onClick?.(e)}
            style={{
                display: 'inline-flex',
                width: width ?? size,
                maxWidth: width ?? size,
                height: height ?? size,
                color: color ?? 'inherit',
                ...style,
            }}
        />
    );
};
